// ---------------------------------------------------------------------------
// 設定の残り7画面（iOS 風、#156、docs/65）の画面の文言。端数処理・使う機能・ユーザー管理・見積の雛形・言葉の言い換え・帳票デザイン・退会。
// それぞれの画面の決まり（docs/21・22・29・31・41・52）と API の文は変えない（ROUNDING_MSG・USER_MSG・VOCAB_MSG・PAPER_MSG などはそのまま）。
// 言葉の置き換え（{trade}・{vendor}・{customer}）は画面の t() が通す
// ---------------------------------------------------------------------------
import { TEMPLATE_MSG } from "./estimateTemplate.js";

export const REST_MSG = {
  // ---- 端数処理（docs/65 §3）----
  roundingTitle: "端数処理",
  roundingSectionYen: "1円未満の端数",
  roundingLine: "明細・率の行",
  roundingTax: "消費税",
  roundingTaxNote: "消費税は税率ごとの合計に1回。顧客ごとの変更は顧客の画面",
  roundingSectionNegative: "マイナスの金額",
  roundingNegative: "基準",
  roundingFootNote: "新規の見積から適用します。作成中の見積は見積の画面の「既定値で再計算」で反映できます。発行済みは変わりません",

  // ---- 使う機能（docs/65 §4）----
  featuresSectionLines: "見積の行",
  featuresSectionVendor: "外注・地図",
  /** 営業力は言葉どおり */
  featuresSectionVendorEigyo: "{vendor}・地図",
  /** 受け取った書類（../eigyouryoku/docs/13 §4.4） */
  featuresSectionDocs: "書類",
  /** #289：{ongoingProject}（継続案件）の節 */
  featuresSectionProjects: "{project}",
  featuresNote: "「使わない」にすると画面から隠れるだけで、データは消えません",
  featuresDefaultOn: "既定：使う",
  featuresDefaultOff: "既定：使わない",

  // ---- ユーザー管理（docs/65 §5 → #287、2026-11-01 射場さん ★1 A・★2・★3、docs/100）----
  //   「招待」をやめて「追加」＋「案内メール」、状態は 設定待ち／利用中／停止中、「席」は「利用人数」、「外す」は「除外」
  usersTitle: "ユーザー管理",
  /** 題の右の作成のボタン（#287） */
  invite: "＋ 追加",
  usersSectionPlan: "料金プラン",
  usersSectionUsers: "ユーザー",
  /** 料金プランの行の右「3／3人」 */
  seats: "{used}／{limit}人",
  seatsIncludes: "（{parts}を含みます）",
  seatsInvited: "設定待ち {n}人",
  seatsDisabled: "停止中 {n}人",
  you: "（あなた）",
  noName: "（氏名が未登録）",
  lastLogin: "最終ログイン {at}",
  neverLoggedIn: "ログイン履歴なし",
  invitedOn: "設定待ち（{md} 案内送信）",
  disabledRow: "停止中・{role}",
  /** ユーザー一覧の節の「？」。{project} は画面が t() で埋める */
  usersHelp: "除外した利用者は一覧に出ません。{project}・見積の担当者名はそのまま残ります。同じメールアドレスで追加すると、同じ利用者として戻ります。",
  inviteTitle: "ユーザー追加",
  /** 題の下の1文（#185 → #186 → #287） */
  inviteLead: "追加する利用者の氏名とメールアドレスを入力してください。",
  /** 窓の右上のチップ（#287）。上限のときは朱で seatsChipFull を足す */
  seatsChip: "利用人数 {used}／{limit}人",
  seatsChipFull: "（上限）",
  send: "追加",
  sending: "追加しています…",
  sectionName: "氏名",
  email: "メールアドレス",
  emailNote: "このアドレスにパスワード設定の案内メールを送信します",
  /** メールアドレスの欄の「？」（{product} は製品名） */
  emailHelp: "相手がすでに{product}を利用している場合は、ログインするとこの会社が追加されます。",
  sectionRole: "権限",
  role: "権限",
  roleNote: "管理者は設定・ユーザー管理・料金プランも利用できます",
  roleHelp: "担当者：見積・請求の業務をすべて利用できます。管理者：さらに設定・ユーザー管理・料金プラン・退会も利用できます。",
  editTitle: "ユーザー修正",
  /** 修正の窓のスイッチ（つまみ＋名前。オフ＝停止中。#287） */
  enabled: "利用",
  enabledHelp: "オン：この会社にログインできます。オフ（停止中）：この会社にはログインできません（他の会社はそのまま）。停止中の利用者も利用人数に数えます。",
  remove: "この会社から除外",
  removeNote: "除外後も、{project}・見積の担当者名は残ります",
  /** 除外の確かめの窓（{name}・{project}） */
  removeAsk: "{name} さんをこの会社から除外しますか",
  removeBody: "除外すると、この会社にログインできなくなります。担当した{project}・見積書・請求書の担当者名と実績は残ります。同じメールアドレスで追加すると、同じ利用者として戻ります。",
  removeYes: "除外",
  resend: "案内メール再送",
  cancelInvite: "追加取消",
  lastAdminRole: "管理者が {name} さん1人のため、担当者にできません。先に他の利用者を管理者にしてください",
  lastAdminEnabled: "最後の管理者は停止中にできません",
  lastAdminRemove: "最後の管理者は除外できません。先に他の利用者を管理者にしてください",

  // ---- 見積書のテンプレート（docs/65 §6。#197 で名前を「見積の雛形」から「見積書の雛形」→ 同じ日の夕に「テンプレート」へ。作成のボタンも）----
  templatesTitle: TEMPLATE_MSG.listTitle,
  edit: "編集",
  done: "完了",
  /** 行の2行目 */
  templateLines: "{n}行・{md} 更新",
  templateEmpty: "まだ空・{md} 更新",
  templateCount: "{n}件／上限 {limit}件",
  templatesNone: "まだテンプレートはありません",
  newTemplate: TEMPLATE_MSG.create,
  create: "作成",
  templateTitle: TEMPLATE_MSG.titleLabel,
  templateSheetNote: "次の画面で、見積書と同じ形で明細を入力します",
  templateRemove: "{title}削除",
  templateEditNote: "⊖ を押すと確認してから削除します（作成済みの見積書は変わりません）",
  /** 削除の窓・通知（#197：言葉の決まり 消す→削除・作る→作成） */
  templateRemoveBody: "このテンプレート（{n}行）を削除します。元に戻せません。",
  templateRemoveHint: "このテンプレートから作成した見積書は変わりません。",
  templateRemoved: "テンプレートを削除しました。作成済みの見積書は変わりません。",
  /** 削除の窓の名前（読み上げ） */
  templateRemoveTitle: "テンプレート削除",

  // ---- 言葉の言い換え（docs/65 §7）----
  wordsTitle: "言葉の言い換え",
  wordsSectionPreset: "業種に合わせた言葉",
  wordsSectionWords: "言い換え",
  wordsNote: "出したあとの見積書・請求書の PDF は変わりません",
  presetSaved: "「{name}」にしました。メニューや帳票の見出しが変わります",
  word: "言葉",
  wordNote: "空なら既定（{base}）。{max}文字まで",
  wordsSectionSuggest: "よく使う言葉",
  wordsSectionWhere: "出るところ",

  // ---- 帳票デザイン（docs/65 §8）----
  paperTitle: "帳票デザイン",
  paperSectionDefaults: "会社の既定の書式",
  paperDefaultsNote: "顧客ごとの書式は顧客の画面で。発行済みの帳票は変わりません",
  paperSectionOwn: "カスタム書式",
  paperOption: "帳票デザインのオプション",
  paperOptionOff: "使っていません",
  paperOptionNote: "月額 500円（税抜）。プリセットから起こして、パソコンのエディタで修正できます",
  paperSectionPresets: "プリセット",
  paperPresetsNote: "選択した書式を会社の既定に設定します",
  paperOwnSub: "{size}・{orient}・{md} 更新",
  paperOwnEdit: "修正",
  paperOwnView: "表示",
  paperOwnNew: "新規作成（{n}／3）",
  paperOwnNote: "帳票デザインはパソコンのみご利用いただけます。",
  paperNewTitle: "新しい書式",
  paperNewFrom: "元のプリセット",
  paperRemove: "{name}削除",
  paperRemoveAsk: "書式削除",
  paperRemoveBody: "この書式を削除します。元に戻せません。発行済みの帳票は変わりません。",
  /** 担当者の注（設定のメニューと同じ文） */
  memberNote: "会社の設定は管理者が変えます",

  // ---- 退会（docs/65 §9）----
  closeTitle: "退会",
  closeSectionWhat: "退会するとどうなるか",
  closeBackupNote: "消したあとも、サーバーのバックアップには保持期間（数週間）のあいだ残り、その後に消えます",
  closeSectionExport: "データを持ち出す",
  closeExport: "見積書・請求書と一覧（zip）",
  closeExportValue: "ダウンロード",
  closeExportStarted: "ダウンロードが始まります。書類が多いと数十秒かかります",
  closeExportNote: "請求書の控えは7年の保存が必要です",
  closeSectionReasons: "アンケート",
  closeQuestionProduct: "製品内容",
  closeQuestionDestination: "移行先",
  closeReasonText: "退会理由",
  closeReasonsNote: "回答は任意です。会社名と結びつけず、集計に使います",
  closeReasonTextNote: "お名前や連絡先は書かないでください。運営担当者が改善の参考に確認し、30日後に完全に削除します",
  closeSectionConfirm: "確かめ",
  closePassword: "いまのパスワード",
  closeConfirm: "{days}日後にデータが消えることを分かったうえで退会する",
  closeConfirmSub: "請求書の控えは持ち出しました（または要りません）",
  closeButton: "退会",
  closeBusy: "手続きしています…",
  closeButtonNote: "パスワードと確かめの ✓ がそろうと押せます",
} as const;
